(function () {
  function normalize(value) {
    return (value || '').toLowerCase().trim();
  }

  function expandItem(dt) {
    const button = dt.querySelector('button');
    const panel = dt.nextElementSibling;

    if (!button || !panel || panel.tagName !== 'DD') return;

    button.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    panel.style.display = '';
  }

  function filterFaq(input) {
    const accordion = document.querySelector('.faq-accordion');
    if (!accordion) return;

    const query = normalize(input.value);
    const items = accordion.querySelectorAll('dt.lb-faq-item');
    const sectionHeadings = accordion.querySelectorAll('.lb-faq-section-heading');
    const sectionNav = document.querySelector('.lb-faq-section-nav');
    const emptyEl = document.querySelector('.lb-faq-search__empty');
    const visibleSections = new Set();
    let visibleCount = 0;

    items.forEach(function (dt) {
      const panel = dt.nextElementSibling;
      const section = dt.dataset.faqSection || '';
      const haystack = normalize(
        section + ' ' + dt.dataset.faqQuestion + ' ' + dt.dataset.faqAnswer
      );
      const match = !query || haystack.indexOf(query) !== -1;

      dt.hidden = !match;
      if (panel && panel.tagName === 'DD') {
        panel.hidden = !match;
      }

      if (match) {
        visibleCount += 1;
        if (section) visibleSections.add(section);
        if (query) expandItem(dt);
      }
    });

    sectionHeadings.forEach(function (heading) {
      const section = heading.dataset.faqSection || heading.textContent.trim();
      heading.hidden = query ? visibleSections.has(section) === false : false;
    });

    if (sectionNav) {
      sectionNav.querySelectorAll('.lb-faq-section-nav__item').forEach(function (item) {
        const link = item.querySelector('a');
        if (!link) return;
        item.hidden = query ? visibleSections.has(link.textContent.trim()) === false : false;
      });
      sectionNav.hidden = query && visibleSections.size === 0;
    }

    if (emptyEl) {
      emptyEl.hidden = !query || visibleCount > 0;
    }
  }

  function initFaqSearch() {
    const input = document.getElementById('lb-faq-search-input');
    if (!input) return;

    const kbd = document.querySelector('.lb-faq-search__kbd');
    if (kbd) {
      kbd.textContent = /Mac|iPhone|iPad|iPod/.test(navigator.platform) ? '⌘K' : 'Ctrl K';
    }

    let debounceTimer;
    input.addEventListener('input', function () {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () {
        filterFaq(input);
      }, 120);
    });

    document.addEventListener('keydown', function (event) {
      const key = event.key.toLowerCase();

      if ((event.metaKey || event.ctrlKey) && key === 'k') {
        event.preventDefault();
        input.focus();
        input.select();
        return;
      }

      if (key === 'escape' && document.activeElement === input) {
        input.value = '';
        filterFaq(input);
        input.blur();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqSearch);
  } else {
    initFaqSearch();
  }
})();
